<template>
  <section v-if="columns"
    :class="{
      'section': true,
      'bg-light2': background
    }">
    <div class="container container-small row">
      <div class="col slide-in"
           :class="{'visible' : visible}"
           v-for="(col, index) in columns"
           :key="'col' + index">
          <h2 class="accent">
            {{ col.title }}
          </h2>
          <p class="text-m paragraph">
            {{ col.text }}
          </p>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'TwoColumnsSection',
  props: ['columns', 'background', 'visible']
}
</script>

<style scoped lang="scss">
  .section {
    .container {
      padding: $gap-xl 0 ($gap-xl * 2);
    } // END .container;

    h2 {
      font-size: $font-l;

      .font-size-l & {
        font-size: $font-xl;
      }

      @include screen ('md') {
        font-size: $font-xl;

        .font-size-l & {
          font-size: $font-xl-mobile;
        }
      } // END @include screen ('md');
    } // END h2;

    p {
      min-height: 100px;
      padding: 40px 0 50px 0;
      text-align: left;
      width: 100%;
      max-width: 350px;

      @include screen ('sm') {
        padding: 35px 0 50px 50px;
      }
      @include screen ('md') {
        padding: 35px 0 30px 100px;
      }
    } // END p;
  } // END .section
</style>
